import { fetchUrl } from './fetchUrl';
import { Accommodation, AccommodationEntity } from '../models/Accommodation';

export async function fetchAccommodationDetail(accommodationId: string) {
    return fetchUrl<AccommodationEntity>({
        endpoint: `/v2/accommodations/${accommodationId}?include=content,images`,
        method: 'GET',
    }).then(accommodation => new Accommodation(accommodation));
}
